import { Option, User } from '../../../../../types';

export const toUserOptions = (data: User[]): Option<string>[] =>
  data.map(({ name, id }) => ({ label: name, value: id, meta: undefined }));
